/**
 * User-facing copy for the connection-request flow-restart states.
 *
 * Kept in plain string constants so apostrophes don't need JSX entity escaping
 * (`&apos;`) inline in the markup. Strings are pre-collapsed to single spaces to
 * match how JSX would have rendered the original multi-line text nodes.
 */
export const CONNECTION_RESTART_COPY = {
  alreadyPending:
    "We're unable to proceed with this step as you've previously sent a connection request to this candidate, and it's pending confirmation. You can choose to perform the below actions",
  maxPendingLimitPrefix:
    "We're unable to proceed with this step, because you have reached the maximum pending connection request limit. So Please",
  maxPendingLimitSuffix:
    'and withdraw some connection requests to excute this step',
  alreadyRejected:
    "We're unable to proceed with this step, because the candidate has recently rejected your connection request. You can choose to perform the below actions",
  emailRequired:
    "We're unable to proceed with this step, because the candidate has set restrictions, allowing invitations only from senders who know their email address",
  toSelf:
    "We're unable to proceed with this step, because you are trying to send the connection request to yourself",
} as const;
